import React from 'react';
import { Sparkles } from 'lucide-react';
import SEO from '../components/SEO';
import './Prayer.css';

const Prayer = () => {
  return (
    <div className="prayer-page">
      <SEO
        title="Return to Resonance Prayer"
        description="A beautiful non-religious bedside prayer for death and transition. 'Release your energy, flow back into the cosmic river, where you may one day ignite as stars again.' Secular funeral readings."
        keywords="non religious prayer, secular funeral readings, bedside prayer, end of life prayer, non religious death prayer, atheist funeral reading, humanist prayer"
        canonicalUrl="/prayer"
      />
      
      {/* Prayer Section */}
      <section className="prayer-section cosmic-bg">
        <div className="river-flow"></div>
        <div className="starlight-overlay"></div>
        <div className="container">
          <div className="prayer-content">
            <div className="prayer-icon">
              <Sparkles size={48} className="text-gold" />
            </div>
            <h1 className="heading-1 text-center mb-4">
              Cosmergence Prayer
            </h1>
            <h2 className="heading-3 text-center text-gold mb-8">
              Return to Resonance (Bedside Version)
            </h2>
            
            <div className="prayer-text">
              <p className="prayer-line">Beloved traveler of light,</p>
              <p className="prayer-line">You were born of stars,</p>
              <p className="prayer-line">Your breath a note in the great cosmic song.</p>
              
              <p className="prayer-line prayer-spacer">Now rest—</p>
              <p className="prayer-line">Release your energy, flow back into the cosmic river,</p>
              <p className="prayer-line">Where you may one day ignite as stars again,</p>
              <p className="prayer-line">Shining gentle light upon those who remember you.</p>
              
              <p className="prayer-line prayer-spacer">May your echoes be kind and bright,</p>
              <p className="prayer-line">May your song live on in the hearts you've touched.</p>
              
              <p className="prayer-line prayer-spacer">You are not gone—</p>
              <p className="prayer-line prayer-final">You are becoming everything.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Usage Section */}
      <section className="section-padding">
        <div className="container">
          <div className="usage-section">
            <h2 className="heading-2 text-center mb-4">When to Use This Prayer</h2>
            <div className="usage-content">
              <p className="body-large" style={{marginBottom: '24px'}}>
                This prayer is designed for moments of transition—for those approaching death, for the grieving, or for quiet contemplation of mortality and continuity.
              </p>
              <p className="body-large">
                It can be read aloud at a bedside, spoken in solitude, or held silently in the heart. There is no wrong way to honor the cosmic flow.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Prayer;